import styled, { createGlobalStyle } from 'styled-components';

export const FieldTooltipGlobalStyle = createGlobalStyle`
  .field-tooltip .ant-tooltip-inner {
    padding: ${(props): string => props.theme.kcc.spacing.XS};
    overflow: hidden;
    border-radius: 0 !important;
  }
`;

export const StyledFieldTooltipContent = styled.div`
  width: 232px;
  gap: ${(props): string => props.theme.kcc.spacing.XS};
  display: flex;
  flex-direction: column;

  .field-tooltip-content__img {
    width: 100%;
    display: block;
  }

  .field-tooltip-content__text {
    color: ${(props): string => props.theme.kcc.colors.WHITE};
    margin: 0;
  }
`;
